import {
  Currency,
  PickingType,
  RequestStatusEnum,
  RRPurposeEnum,
} from '../lib/enums';
import { BaseModel } from './index';
import { Issuance, Summary } from './MaterialRequest';

export interface ReceivingReportRecord {
  files?: any;
  id: string;
  logRevisionId?: string;
  createdBy?: string;
  updatedBy?: string;
  code?: string;
  timeCreated?: string;
  timeUpdated?: string;
  active?: boolean;
  requiredDate: string;
  source: string;
  type: PickingType | null;
  notes: string;
  vendor: BaseModel | undefined;
  destination: BaseModel | undefined;
  status: RequestStatusEnum;
  subTotal: number | null;
  rrPurpose: RRPurposeEnum | null;
  total: number | null;
  drNo: string;
  approvedBy?: string;
  invoiceNo: string;
  receivedDate: string | null;
  currency: string;
  vat: number | null;
  discount: number | null;
  wtax: number | null;
  movements: RRMovement[];
  issuance: Issuance[];
  summary: Summary[];
}

export interface RRMovement {
  id: string;
  uuid: string;
  proderNo?: string;
  sku?: string;
  product: BaseModel | undefined;
  description: string;
  requestQty: number;
  requestUom: BaseModel | undefined;
  quantity: number;
  productUom: BaseModel | undefined;
  status: string;
  unitPrice: number;
  subTotal: number;
}

export const RRNextStatus = (mrStatus?: RequestStatusEnum | undefined) => {
  let newStatus: any;
  switch (mrStatus) {
    case 'DRAFT':
      newStatus = 'CONFIRM';
      break;
    case 'CONFIRM':
      newStatus = 'APPROVED';
      break;
    case 'APPROVED':
      newStatus = 'DONE';
      break;
    case 'AVAILABLE':
      newStatus = 'DONE';
      break;
    default:
      newStatus = mrStatus;
      break;
  }
  return newStatus;
};

export const initialFormData = {
  id: '',
  logRevisionId: '',
  createdBy: '',
  updatedBy: '',
  code: '',
  timeCreated: '',
  timeUpdated: '',
  active: true,
  requiredDate: '',
  source: '',
  type: null,
  notes: '',
  vendor: undefined,
  destination: undefined,
  status: RequestStatusEnum.DRAFT,
  rrPurpose: null,
  subTotal: null,
  total: null,
  drNo: '',
  invoiceNo: '',
  receivedDate: '',
  currency: Currency.PHP,
  vat: null,
  discount: null,
  wtax: null,
  movements: [],
  issuance: [],
  summary: [],
};

export interface ReceivingReportFilter {
  from: string | null;
  to: string | null;
  proder?: string | null | undefined;
  sku?: string | null | undefined;
  status?: string | null | undefined;
  datepicker?: (string | null)[];
}
export interface ReceivingReportStatusForm {
  status: string;
  remarks: string;
}
